export default function () {
  try {
    return (
      !!window.RTCPeerConnection &&
      typeof new window.RTCPeerConnection().createDataChannel === 'function'
    );
  } catch (e) {
    return false;
  }
}
